import { useMutation } from '@tanstack/react-query';

import { fetchStartIdpProcess } from '../api/startIdpProcess.js';

export function useStartIdpProcessMutation() {
  return useMutation({
    mutationKey: ['dosespot-idp', 'start'],
    mutationFn: async () => {
      return await fetchStartIdpProcess();
    },
  });
}
